"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metric = void 0;
const axios_1 = __importDefault(require("axios"));
const MetricDensity_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/MetricDensity"));
const main_1 = require("@common/tsutils/statistics/main");
// 2 or more
// Beatriz said 5
const MIN_NUM_SAMPLES_FOR_STATS = 5;
class Metric {
    constructor(boxplot, raw, dimension) {
        this.clusterDensities = [];
        this.becropScoreChange = 0;
        this.probability = null;
        this.dimension = 'bio';
        this.code = raw.code_name;
        this.name = raw.name;
        this.typeCode = raw.type_code;
        this.numClusters = raw.num_clusters;
        this.numSamples = raw.num_samples;
        this.boxplot = boxplot;
        this.dimension = dimension || 'bio';
        this.unitMetric = '';
        dimension === 'bio' ? (this.unit = 'BCS') : (this.unit = '%');
        const re = /NF-(.+)/;
        const res = re.exec(this.typeCode);
        if (res) {
            const nutrient = res[1];
            this.name = nutrient + ': ' + this.name;
        }
    }
    bothHaveSamples() {
        var _a, _b;
        return (((_a = this.clusterDensities[0]) === null || _a === void 0 ? void 0 : _a.samples.length) > 0 &&
            ((_b = this.clusterDensities[1]) === null || _b === void 0 ? void 0 : _b.samples.length) > 0);
    }
    atLeastOneSampleDetectedInAnyCluster() {
        return (this.clusterDensities[0].samples.some((s) => s.raw_rank && s.raw_rank > 0) ||
            this.clusterDensities[1].samples.some((s) => s.raw_rank && s.raw_rank > 0));
    }
    /**
     * @deprecated
     */
    async load() {
        await Metric.load([this], 'bio');
    }
    loadInner(listA, listB, dimension) {
        if (listA && listB) {
            this.clusterDensities = [
                new MetricDensity_1.default(listA, this.boxplot.clusters[0].samples, dimension),
                new MetricDensity_1.default(listB, this.boxplot.clusters[1].samples, dimension),
            ];
        }
        this.unitMetric =
            this.clusterDensities[0].samples.length > 0
                ? this.clusterDensities[0].samples[0].unit
                : this.clusterDensities[1].samples[0].unit;
        if (dimension === 'bio') {
            this.becropScoreChange =
                this.clusterDensities[1].avg - this.clusterDensities[0].avg;
        }
        if (dimension === 'phch') {
            if (this.clusterDensities[0].avg === 0) {
                this.becropScoreChange = Math.round(this.clusterDensities[1].avg);
            }
            this.becropScoreChange = Math.round(((this.clusterDensities[1].avg - this.clusterDensities[0].avg) /
                this.clusterDensities[0].avg) *
                100);
        }
        const x = this.clusterDensities[0].values;
        const y = this.clusterDensities[1].values;
        if (x.length >= MIN_NUM_SAMPLES_FOR_STATS &&
            y.length >= MIN_NUM_SAMPLES_FOR_STATS) {
            if (this.code !== 'SHI') {
                this.probability = {
                    type: 'p-value',
                    value: (0, main_1.tTestTwoSamplePValue)(x, y),
                    method: 't-student',
                };
            }
            else {
                this.probability = {
                    type: 'p-value',
                    value: (0, main_1.mannWhitneyTestTwoSamplePValue)(x, y),
                    method: 'mann-withney',
                };
            }
        }
    }
    static async load(metrics, dimension) {
        var _a;
        const codes = metrics.map((m) => m.code);
        const boxplot = (_a = metrics[0]) === null || _a === void 0 ? void 0 : _a.boxplot;
        const data = {
            clusters: boxplot === null || boxplot === void 0 ? void 0 : boxplot.getClusterPayload(),
            metric_code_names: codes,
            phch_metric_code_names: codes,
        };
        const urlBio = '/toolkit/wbp_metrics/metricCompare';
        const response = (await axios_1.default.post(urlBio, data)).data;
        metrics.forEach((metric) => {
            let listA = {
                code: '',
                samples: '',
                ranks: '',
                raw_ranks: '',
                unit: '',
            };
            let listB = {
                code: '',
                samples: '',
                ranks: '',
                raw_ranks: '',
                unit: '',
            };
            if (dimension === 'bio') {
                const findMetric = (x) => {
                    return x.code === metric.code;
                };
                listA = response.microbiological[0].find(findMetric) || null;
                listB = response.microbiological[1].find(findMetric) || null;
            }
            if (dimension === 'phch') {
                const findMetric = (x) => {
                    return x.code === metric.code;
                };
                listA = response.phch[0].find(findMetric) || null;
                listB = response.phch[1].find(findMetric) || null;
            }
            if (listA && listB) {
                metric.loadInner(listA, listB, dimension);
            }
        });
    }
}
exports.Metric = Metric;
